import { normalizePhrase } from "./normalizePhrase";
import { VOICE_INTENT_REGISTRY } from "./voiceIntentRegistry";

/**
 * @param {string} transcript
 * @param {typeof VOICE_INTENT_REGISTRY} [registry]
 * @returns {{ intentId: string, confidence: "exact" | "prefix" } | null}
 */
export function resolveVoiceIntent(transcript, registry = VOICE_INTENT_REGISTRY) {
  const normalized = normalizePhrase(transcript);
  if (!normalized) {
    return null;
  }

  let bestMatch = null;

  for (const intent of registry) {
    for (const phrase of intent.phrases) {
      const normalizedPhrase = normalizePhrase(phrase);
      if (!normalizedPhrase) {
        continue;
      }

      if (normalized === normalizedPhrase) {
        const candidate = {
          intentId: intent.id,
          confidence: "exact",
          phraseLength: normalizedPhrase.length,
          rank: 2,
        };
        if (
          !bestMatch ||
          candidate.rank > bestMatch.rank ||
          (candidate.rank === bestMatch.rank &&
            candidate.phraseLength > bestMatch.phraseLength)
        ) {
          bestMatch = candidate;
        }
        continue;
      }

      if (
        normalized.startsWith(`${normalizedPhrase} `) &&
        normalizedPhrase.length >= 3
      ) {
        const candidate = {
          intentId: intent.id,
          confidence: "prefix",
          phraseLength: normalizedPhrase.length,
          rank: 1,
        };
        if (
          !bestMatch ||
          candidate.rank > bestMatch.rank ||
          (candidate.rank === bestMatch.rank &&
            candidate.phraseLength > bestMatch.phraseLength)
        ) {
          bestMatch = candidate;
        }
      }
    }
  }

  if (!bestMatch) {
    return null;
  }

  return {
    intentId: bestMatch.intentId,
    confidence: bestMatch.confidence,
  };
}
